<template>
  <section >
    <navbar></navbar>
    <div class="ew-bg-gray">
    <section class="container">
      <div class="row">
        <div class="col pb-3">
          <router-view/>
        </div>
      </div>

    </section>
    </div>
  <footer-simple class="ew-mar-none"></footer-simple>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from './Navbar'
import FooterSimple from './FooterSimple'

export default {
  name: 'Dashboard',
  data () {
    return {}
  },
  created () {
    this.getUser()
  },
  methods: {
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user'])
  },
  components: {
    'navbar': Navbar,
    'footer-simple': FooterSimple
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/variables";

  .ew-sidenav {
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      
    .nav-item {
      .nav-link {
        color: #444;
        padding: 0.35rem 0.5rem ;

        img {
          margin-right: 0.5rem;
        }

        &.active {
  
          background-color: transparentize($primary, 0.85);
          color: $primary;
          box-shadow: 0 5px 0 $primary;
        }
        &:hover {
          background-color: transparentize($primary, 0.90);
          color: $primary;
          box-shadow: 0 5px 0 $primary;
          
        }
        
      }
    }
  }

  @media (max-width: 1199px) {
    .ew-sidenav .nav-item .nav-link img[data-v-c9ef1a98] {
      width: 30px;
      height: 30px;
      margin-right: 0.2rem;
    }
    .ew-sidenav .nav-item .nav-link {
      font-size: 0.8rem;
    }
  }
  @media (max-width: 991px) {
    .ew-sidenav .nav-item .nav-link img[data-v-c9ef1a98][data-v-c9ef1a98] {
      width: 18px;
      height: 18px;
    }
    .ew-sidenav[data-v-c9ef1a98] {
      margin-right: 2rem;
    }
  }
  @media (max-width: 767px) {
    .ew-sidenav .nav-item .nav-link img[data-v-c9ef1a98][data-v-c9ef1a98][data-v-c9ef1a98] {
      width: 36px;
      height: 36px;
    }
    .ew-sidenav .nav-item .nav-link[data-v-c9ef1a98] {
      font-size: 0.9375rem;
    }
    .mt-5{
      margin-top: 1rem !important;
    }
    .no-gutters .col-md-3{
      margin-bottom: 3rem;
    }
    select[data-v-2dcb1cf7] {
      font-size: 0.7rem;
    }
  }
.ew-mar-none{
  margin-top: 0
}

.ew-menu-hz{
  padding-top: 2rem;
  padding-bottom: 1rem
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue